/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, days: NonNullable<unknown> }} Partner_Org_Contract_State_DormantInputs */



/**
* | output |
* | --- |
* | "Asleep until {date}, in {days} days. Nothing is billed and nobody can sign in yet. The prepaid budget is added automatically when the term begins." |
*
* @param {Partner_Org_Contract_State_DormantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_state_dormant = /** @type {((inputs: Partner_Org_Contract_State_DormantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_State_DormantInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Inaktiv bis ${i?.date}, in ${i?.days} Tagen. Es wird nichts abgerechnet und niemand kann sich anmelden. Das vorausbezahlte Budget wird zu Laufzeitbeginn automatisch gutgeschrieben.`)
	return /** @type {LocalizedString} */ (`Asleep until ${i?.date}, in ${i?.days} days. Nothing is billed and nobody can sign in yet. The prepaid budget is added automatically when the term begins.`)
});